import React from 'react';
import { useAlimentContext } from '../../../contexts/aliments/aliment.tsx';

const AlimentHeader = () => {
  const { aliment } = useAlimentContext();
  return (
    <div>
      <h1>{aliment.name ?? "Create aliment"}</h1>
    </div>
  );
};

export default AlimentHeader;
